// hooks/useDarkMode.js
import { useState, useEffect } from 'react';

export function useDarkMode() {
  // const [isDark, setIsDark] = useState(() =>
  //   window.matchMedia('(prefers-color-scheme: dark)').matches
  // );
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [isDark]);

  const toggle = () => setIsDark((prev) => !prev);

  return { isDark, toggle };
}
